import { ColDef, ColGroupDef } from '@ag-grid-community/core';
import getHours from 'date-fns/getHours';
import parse from 'date-fns/parse';
import formatDate from 'date-fns/format';
import { formatColumnDate, dateFilterParams, headerInfoTooltipDef } from '../lib/utils';

const defaultFilterParams = {
  newRowsAction: 'keep',
};

export default [
  {
    cellClass: 'ticker-cell',
    cellRenderer: 'tickerWidgetCell',
    field: 'ticker',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    initialWidth: 60,
    ...headerInfoTooltipDef('Symbol associated with the company who is having the conference call'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: ({ data }: any) => {
      return (
        <div className="company-name-cell">
          <span>{data.name}</span>
          {data.logo && <img alt="" className="bz-ag-table__company-image" loading="lazy" src={data.logo}></img>}
        </div>
      );
    },
    field: 'name',
    filter: 'agSetColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      defaultToNothingSelected: true,
    },
    headerName: 'Company Name',
    initialWidth: 160,
    ...headerInfoTooltipDef('Full name of company associated to ticker'),
  },
  {
    cellClass: 'ticker-cell',
    field: 'date',
    filter: 'agDateColumnFilter',
    filterParams: {
      ...defaultFilterParams,
      ...dateFilterParams,
      buttons: ['clear'],
      inRangeInclusive: true,
    },
    headerName: 'Call Date',
    initialSort: 'asc' as ColDef['initialSort'],
    initialWidth: 80,
    valueFormatter: ({ data }) => formatColumnDate(data.date),
    valueGetter: ({ data }) => {
      if (!data.date) return null;

      return data.date;
    },
    ...headerInfoTooltipDef('Date of Call'),
  },
  {
    cellClass: 'ticker-cell',
    field: 'start_time',
    filter: 'priceFilter',
    filterParams: {
      ...defaultFilterParams,
      buttons: ['clear'],
      values: [
        {
          label: 'AM',
          rules: (value: number) => {
            return getHours(value) < 13;
          },
        },
        {
          label: 'PM',
          rules: (value: number) => {
            return getHours(value) >= 13;
          },
        },
      ],
    },
    headerName: 'Start Time',
    initialWidth: 70,
    valueFormatter: ({ value }) => {
      if (!value) return '';

      return formatDate(value, 'h:mm a');
    },
    valueGetter: ({ data }) => {
      if (!data.start_time) return '';

      return parse(data.start_time, 'HH:mm:ss', new Date());
    },
    ...headerInfoTooltipDef('Time of Call'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: ({ data }: { data: any }) => {
      if (!data.webcast_url) return '';
      return (
        <a href={data.webcast_url} rel="noreferrer" target="_blank">
          {data.webcast_url}
        </a>
      );
    },
    field: 'webcast_url',
    headerName: 'Webcast',
    initialWidth: 180,
    suppressMenu: true,
    ...headerInfoTooltipDef('URL For Joining the Call’s Webcast'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: ({ data }: { data: any }) => {
      if (!data.phone_num) return '-';
      return (
        <a href={`tel:${data.phone_num}`} rel="noreferrer" target="_blank">
          {data.phone_num}
        </a>
      );
    },
    field: 'phone_num',
    headerName: 'Dial In',
    initialWidth: 100,
    suppressMenu: true,
    ...headerInfoTooltipDef('Dial in number for participants outside of the US'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: ({ data }: { data: any }) => {
      if (!data.access_code) return '-';
      return data.access_code;
    },
    field: 'access_code',
    headerName: 'Access Code',
    initialWidth: 60,
    suppressMenu: true,
    ...headerInfoTooltipDef('Code participants must type in to access call'),
  },
  {
    cellClass: 'ticker-cell',
    cellRenderer: () => {
      return (
        // eslint-disable-next-line react/jsx-no-target-blank
        <a href="https://www.benzinga.com/profile/portfolio/?action=login&utm_source=calendars" target="_blank">
          Get Alert
        </a>
      );
    },
    field: 'get_alert',
    headerName: 'Get Alert',
    initialWidth: 70,
    suppressAutoSize: true,
    suppressMenu: true,
    suppressSizeToFit: true,
  },
] as (ColDef | ColGroupDef)[];
